import { FC, PropsWithChildren } from "react";
import { Size } from "@/types";
import ExpandableBlock from "@/components/ExpandableBlock";

type ExpandableBlockBlockProps = {
  isOpen?: boolean;
  showDivider?: boolean;
  button?: {
    viewMore?: string;
    viewLess?: string;
    dld?: string;
    dlt?: string;
    size?: Size;
    automationId: string;
  };
};

export const ExpandableBlockBlock: FC<
  PropsWithChildren<ExpandableBlockBlockProps>
> = ({ isOpen = false, showDivider = true, button, children }) => {
  return (
    <ExpandableBlock isOpen={isOpen} showDivider={showDivider} button={button}>
      {children}
    </ExpandableBlock>
  );
};
